import type { Tool, ToolContext, PointerInfo } from "./Tool";

/** Click-to-recolor. Applies the current brush color to the clicked tube. */
export class ColorTool implements Tool {
  readonly id = "color";
  readonly name = "Paint";
  readonly hint = "Click a tube to repaint it with the current color.";
  readonly icon = `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M7 3l11 11-5 5a3 3 0 0 1-4 0L3 13 7 3z" />
      <path d="M14 16l3 5 2-1-2-5" />
    </svg>`;

  onPointerDown(info: PointerInfo, ctx: ToolContext): void {
    const hits = info.raycaster.intersectObjects(ctx.design.root.children, true);
    const hit = hits.find((h) => !!ctx.design.findByObject(h.object));
    const tube = hit ? ctx.design.findByObject(hit.object) : null;
    if (!tube) return;
    tube.setColor(ctx.getBrushColor());
    ctx.design.touch();
    ctx.toast("Color applied");
  }
}
